<div *ngIf="isLoading" class="loader my-5"></div>

<div *ngIf="!isLoading" class="col-sm-12 py-5 px-4">
    <h4 class="fs-1">Account</h4>
    <div class="pt-3"></div>

    <div *ngIf="bookedClasses && bookedClasses.length">
      <h4>Up Next</h4>
      <div *ngFor="let c of bookedClasses; trackBy: trackByBookedClass" class="row">
        <df-booked-class [source]="c" [classesTab]="classesTab" />
      </div>

      <div class="pt-3"></div>
    </div>

    <div *ngIf="subscriptions.length" class="row">
      <div class="col-xl-8 col col-sm-12">
          <ul class="mydrop-list">
              <li class="mydrop-list-item" *ngFor="let s of subscriptions; trackBy: trackBySubscription">
                  <div class="card mb-3 py-0">
                      <div class="row g-0 d-table">
                        <div class="col-2 d-table-cell">
                          <img *ngIf="s.PackId | packImage:currencyMeta" [src]="s.PackId | packImage:currencyMeta" [alt]="s.Description" class="card-image"/>
                        </div>
                        <div class="col-7 d-table-cell">
                          <div class="card-body">
                            <h5 class="card-title">
                              {{s.MenuPackId | menuPackName:currencyMeta}}
                            </h5>
                            <p class="card-text">{{s.PackId | subDescription:currencyMeta}}</p>
                            <p *ngIf="getCurrentCreditsLine(s)" class="card-text mb-0"><small class="text-muted">{{getCurrentCreditsLine(s)}}</small></p>
                            <p *ngIf="getNextCycleCreditsLine(s)" class="card-text mb-0"><small class="text-muted">{{getNextCycleCreditsLine(s)}}</small></p>
                            <p *ngIf="getNextBillingDate(s)" class="card-text mb-0">
                              <small [class.text-danger]="subscriptionIsEnding(s)" [class.text-muted]="!subscriptionIsEnding(s)">{{getNextBillingDate(s)}}</small>
                            </p>
                            <p *ngIf="getCommitmentDate(s)" class="card-text mb-0"><small class="text-muted">{{getCommitmentDate(s)}}</small></p>
                            <p *ngIf="getCardErrorMessage(s)" class="card-text mb-0"><small class="text-danger">{{getCardErrorMessage(s)}}</small></p>
                            <div *ngIf="getMembershipTags(s).length" class="mt-1">
                              <span
                                *ngFor="let tag of getMembershipTags(s)"
                                class="badge me-1"
                                [ngClass]="{
                                  'bg-secondary': tag === 'Paused',
                                  'bg-info text-dark': tag === 'Addon',
                                  'bg-warning text-dark': tag === 'Cancellation requested',
                                  'bg-danger': tag === 'Cancelled' || tag === 'Card error' || tag === 'Past due'
                                }"
                              >
                                {{ tag }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-1 d-table-cell align-middle">
                          <div *ngIf="hasDropdownOptions(s)" class="dropdown" [class.show]="activeDropdownId === s.Id">
                            <i class="bi bi-three-dots-vertical three-dots" 
                               (click)="toggleDropdown(s.Id); $event.stopPropagation()" 
                               style="cursor: pointer;"></i>
                            <div class="dropdown-menu" [class.show]="activeDropdownId === s.Id" (click)="$event.stopPropagation()">
                              <a *ngIf="canPauseSubscription(s)" class="dropdown-item" href="javascript:void(0)" (click)="pauseSubscription(s)">
                                <i class="bi bi-pause-circle me-2"></i>Pause Subscription
                              </a>
                              <a *ngIf="canResumeSubscription(s)" class="dropdown-item" href="javascript:void(0)" (click)="resumeSubscription(s)">
                                <i class="bi bi-play-circle me-2"></i>Resume Subscription
                              </a>
                              <a *ngIf="canCancelSubscription(s)" class="dropdown-item" href="javascript:void(0)" (click)="cancelSubscription(s)">
                                <i class="bi bi-x-circle me-2"></i>Cancel Subscription
                              </a>
                              <a *ngIf="canKeepSubscription(s)" class="dropdown-item" href="javascript:void(0)" (click)="cancelCancellationRequest(s)">
                                <i class="bi bi-arrow-counterclockwise me-2"></i>Keep Subscription
                              </a>
                              <a *ngIf="renewAvailable(s)" class="dropdown-item" href="javascript:void(0)" (click)="renew(s)">
                                <i class="bi bi-arrow-counterclockwise me-2"></i>Renew Subscription
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
              </li>
          </ul>
      </div>
    </div>

    <div *ngIf="packs.length" class="row">
      <div class="col-xl-8 col col-sm-12">
          <ul class="mydrop-list">
              <li class="mydrop-list-item" *ngFor="let p of packs; trackBy: trackByPack">
                  <div class="card mb-3 py-0">
                      <div class="row g-0 d-table">
                        <div class="col-2 d-table-cell">
                          <img *ngIf="p.PackId | packImage:currencyMeta" [src]="p.PackId | packImage:currencyMeta" [alt]="p.Description" class="card-image"/>
                        </div>
                        <div class="col-7 d-table-cell">
                          <div class="card-body">
                            <h5 class="card-title">{{descriptionPack(p)}}</h5>
                            <p class="card-text">{{p.PackId | subDescription:currencyMeta}}</p>
                            <p *ngIf="getExpiresDate(p)" class="card-text mb-0">
                              <small [class.text-danger]="packExpiresSoon(p)" [class.text-muted]="!packExpiresSoon(p)">{{getExpiresDate(p)}}</small>
                            </p>
                            <p *ngIf="getCreditsRemaining(p)" class="card-text mb-0"><small class="text-body-secondary text-muted">{{getCreditsRemaining(p)}}</small></p>
                          </div>
                        </div>
                        <!-- <div class="col-1 d-table-cell align-middle">
                          <i class="bi bi-three-dots-vertical three-dots"></i>
                        </div> -->
                      </div>
                    </div>
              </li>
          </ul>
      </div>
    </div>
    <div *ngIf="subscriptions.length || packs.length">
      Have any questions? <a href="/support" class="link-btn blue">Reach out to us.</a>
    </div>
    <div *ngIf="!subscriptions.length && !packs.length" class="card p-4">
      No active subscriptions or packs. <a href="/purchase" class="link-btn blue">Purchase a subscription</a> to get started.
    </div>
    <div class="pt-3" *ngIf="allowDeleteAccount">
      To delete your account, follow instructions here: <a href="/account/delete" class="link-btn blue">Delete account</a>
    </div>
</div>